// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ltr-text[data-v-c4d8303e]{direction:ltr;display:inline-block}", ""]);
// Exports
module.exports = exports;
